import capitalize from "lodash/capitalize";

export const EMPLOYMENT_TYPE_1099 = "1099";

export const codeDisplay = (code) => {
  switch (code) {
    case "unified":
      return "PTO";
    case "california_covid":
      return "COVID";
    case "california_covid_additional":
      return "COVID (additional)";
    case "work_from_home_tracking":
      return "Work From Home";
    default:
      return capitalize(code);
  }
};
